<template>
  <v-app-bar
    app
    dark
    fixed
    class="app-header"
    elevation="2"
  >
    <v-toolbar-title class="header-brand">
      <div class="header-logo-wrap">
        <img
          src="/images/logo-kab.png"
          width="44"
          height="48"
          alt="logo"
          :class="device.desktop ? `animate__animated animate__tada header-logo` : `header-logo`"
          @click="$router.push({name:'home'})"
        >
      </div>
      <div class="header-text">
        <div class="header-title">PEMERINTAH KABUPATEN TANGERANG </div>
        <div class="header-subtitle">APLIKASI PEMANTAUAN CCTV KABUPATEN TANGERANG</div>
      </div>
    </v-toolbar-title>
    <v-spacer />

    <v-menu
      offset-y
      width="300"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-show="device.mobile"
          icon
          dark
          v-bind="attrs"
          v-on="on"
          class="mr-2"
        >
          <v-icon color="white">mdi-menu</v-icon>
        </v-btn>
      </template>
      <v-card
        width="220"
        class="header-mobile-card"
      >
        <v-list>

          <v-list-item>
            <v-list-item-title
              class="header-mobile-item"
              @click="$router.push({name:'login'})"
            >
              Login
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </v-app-bar>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "HeaderComponent",

  data: () => ({}),
  mounted() {},
  computed: {
    ...mapState(["device", "theme", "info", "page"]),
  },
};
</script>

<style scoped>
.app-header {
  height: 84px;
  background: linear-gradient(
    135deg,
    #0f172a 0%,
    #0b3a79 55%,
    #1d4ed8 100%
  ) !important;
  border-bottom: 1px solid rgba(191, 219, 254, 0.25);
}

.header-brand {
  display: flex;
  align-items: center;
}

.header-logo-wrap {
  margin-left: 8px;
  margin-right: 12px;
}

.header-logo {
  cursor: pointer;
}

.header-text {
  line-height: 1.2;
}

.header-title {
  font-size: 15px;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: 0.3px;
}

.header-subtitle {
  font-size: 11px;
  font-weight: 500;
  color: #bfdbfe;
  margin-top: 2px;
}

.header-menu {
  margin-right: 12px;
}

.header-menu-item {
  font-size: 14px;
  color: #dbeafe;
  padding: 6px 12px;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.header-menu-item:hover {
  background: rgba(255, 255, 255, 0.15);
  color: #ffffff;
}

.header-menu-item--active {
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}

.header-mobile-card {
  border-radius: 10px;
}

.header-mobile-item {
  font-size: 14px;
  font-weight: 600;
  color: #1e3a8a;
}

@media (max-width: 960px) {
  .header-title {
    font-size: 13px;
  }

  .header-subtitle {
    font-size: 10px;
  }
}
</style>